module.exports = __webpack_public_path__ + "img/1spade-11.f46b6ca4.svg";